import { forwardRef } from '@chakra-ui/system';
import type { HTMLChakraProps } from '@chakra-ui/system';
import type { PropsWithChildren } from 'react';

import { Heading } from '@frontend/components';

import { useContainerStyles } from './';

export type ContainerTitleProps = PropsWithChildren<unknown> &
  HTMLChakraProps<'div'>;

export const ContainerTitle = forwardRef<ContainerTitleProps, 'div'>(
  ({ children, ...props }: ContainerTitleProps, ref) => {
    const styles = useContainerStyles() ?? {};

    return (
      <Heading ref={ref} sx={styles.containerTitle} {...props}>
        {children}
      </Heading>
    );
  },
);
ContainerTitle.displayName = 'ContainerTitle';
